import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import MenuServices from "services/MenuServices";
import { notifyError, notifySuccess } from "utils/toast";

const useMenu = (id, setSelectedParentId) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      setIsSubmitting(true);

      // console.log("MenuData:", MenuData);
      const MenuData = {

       
        id_parent:data.id_parent,
        icon:data.icon,
        name:data.name,
        sub_parent_name:data.sub_parent_name,
        position:data.position,
        id_sub_parent: data.id_sub_parent,
        path:data.path,
        };


      if (id) {
        const res = await MenuServices.updateMenu(id, MenuData);

        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await MenuServices.addMenu(MenuData);

        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      //  closeDrawer();
    } finally {
      setLoading(false);
    }
  };
  // console.log(res);
  const getMenuData = async () => {
    try {
      const res = await MenuServices.getMenuById(id);
      if (res) {
        setValue("id_sub_parent", res.data.id_sub_parent);

        setValue("path", res.data.path);

        setValue("id_parent", res.data.id_parent);
        setSelectedParentId(res.data.id_parent);
        setValue("icon", res.data.icon);
        setValue("name", res.data.name);
        setValue("sub_parent_name", res.data.sub_parent_name);
        setValue("position", res.data.position);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {

    setValue("path");

      setValue("id_sub_parent");
      setValue("id_parent");
      setValue("icon");
      setValue("name");
      setValue("position");
      setValue("sub_parent_name");
      clearErrors();
      return;
    }

    if (id) {
      getMenuData();
    }
     // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,

    loading,
    setLoading,
  };
};

export default useMenu;
